import OneTimePassword from './OneTimePassword';

export default OneTimePassword;
